import React from 'react';
import logo from 'src/assets/img/logo.svg';
import styles from './Logo.module.scss';

const Logo = () => (
  <img src={logo} alt="Equine 74 logo" className={styles.logo} />
);

export default Logo;
